import { useState } from 'react';
import { FaFacebookF, FaTwitter, FaPinterestP, FaPhoneAlt, FaEnvelope, FaSearch, FaLinkedinIn } from 'react-icons/fa';
import { Link, NavLink } from 'react-router-dom';
import Sidebar from '../../../components/Sidebar/Sidebar';
import useGlobalContext from '../../../hooks/useGlobalContext';

const HomeOneHeader = () => {
   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);
   const { stickyMenu } = useGlobalContext();   

   return (
      <>
         <header>
            <div className="header__area p-relative header__transparent px-3">
               <div className="header__top d-none d-md-block">
                  <div className="container">
                     <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-5 col-md-4">
                           <div className="header__social">
                              <ul>
                                 <li><a target='blank' href="https://www.facebook.com/profile.php?id=100085761911035"><i ><FaFacebookF /></i></a></li>
                                 <li><a target='blank' href="https://twitter.com/VeEstrategica"><i ><FaTwitter /> </i></a></li>
                                 <li><a target='blank' href="https://www.linkedin.com/company/vis%C3%A3o-estrat%C3%A9gica/"><i ><FaLinkedinIn /></i></a></li>
                                 <li><a target='blank' href="https://br.pinterest.com/vestratgica"><i > <FaPinterestP /> </i></a></li>
                              </ul>
                           </div>
                        </div>
                        <div className="col-xl-6 col-lg-7 col-md-8">
                           <div className="header__info f-right">
                              <ul>
                                 <li>
                                    <Link to="tel:(+468)-254-762-443">
                                       <i > <FaPhoneAlt /> </i>
                                       (12) 98182-4886
                                    </Link>
                                 </li>
                                 <li>
                                    <Link to="/contact">
                                       <i > <FaEnvelope /> </i>
                                       suporte@visaoestrategica.tech
                                    </Link>
                                 </li>
                                 <li>
                                    <Link to="/home" className="search-toggle d-none d-lg-block">
                                       <i > <FaSearch /> </i>
                                    </Link>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div id="header__sticky" className={stickyMenu ? "sticky header__bottom" : "header__bottom"}>
                  <div className="container">
                     <div className="row align-items-center">
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                           <div className="logo">
                              <NavLink to="/">
                                 <img src="assets/img/logo/logo_horizontal_transparente_fundo_escuro.png" alt="logo" style={{ width: "170px", marginTop: "10px", marginBottom: "10px" }} />
                              </NavLink>
                           </div>
                           <div className="logo-gradient">
                              <NavLink to="/">
                                 <img src="assets/img/logo/logo_horizontal_transparente.png" alt="logo" style={{ width: "170px", marginTop: "10px", marginBottom: "10px" }} />
                              </NavLink>
                           </div>
                        </div>
                        <div className="col-xl-9 col-lg-9 col-md-6 col-sm-6 col-6">
                           <div className="header__bottom-right d-flex justify-content-end align-items-center">
                              <div className="main-menu menu_wrapper_one">
                                 <nav id="mobile-menu">
                                    <ul>
                                       <li><NavLink to="/">Início</NavLink></li>
                                       <li><NavLink to="/about">Quem somos</NavLink></li>                                       
                                       <li><NavLink to="/serviceSSAD">Empresas Tech</NavLink></li>
                                       <li><NavLink to="/serviceSSADGov">Cidades Tech</NavLink></li>                                       
                                    </ul>
                                 </nav>
                              </div>
                              <div className="header__btn d-none d-sm-block d-lg-none d-xl-block ml-50">
                                 <Link to="/contact" className="z-btn-home z-btn-transparent-home">Contato</Link>
                              </div>
                              <div onClick={handleShow} className="sidebar__menu d-lg-none">
                                 <div className="sidebar-toggle-btn" id="sidebar-toggle">
                                    <span className="line"></span>
                                    <span className="line"></span>
                                    <span className="line"></span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="header__search-wrapper">
                  <div className="container">
                     <div className="row">
                        <div className="col-xl-12">
                           <form action="#">
                              <input type="text" placeholder="Your Keywords" />
                              <button type="button"><i > <FaSearch /> </i></button>
                           </form>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="body-overlay-2"></div>
            </div>
         </header>

         <Sidebar show={show} handleClose={handleClose} />

      </>
   );
};

export default HomeOneHeader;